module.exports = __webpack_public_path__ + "be8707f391b060efb6682e19a6711345.png";